import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import routesConfig from "./config";
import { message } from "antd";
// import { auth } from '@api/login';
import bus from "@utils/bus";
import { filterPermission } from "@utils/tool";

class DefineRoute extends Component {
    handleAuth() {
        this.setState({
            isLogin: bus.me && bus.me.meta.errCode === 0 ? true : false
        });

        if (bus.me && bus.me.meta.errCode !== 0) {
            message.error(bus.me.meta.errMsg);
        }
    }

    state = {
        isLogin: false
    };

    componentWillMount() {
        this.handleAuth();
        bus.subscribe("forbidden", this.forbidden.bind(this));
    }

    componentWillUnmount() {
        bus.unSubscribe(["loadingChange"]);
    }

    forbidden() {
        setTimeout(() => {
            this.setState({ isLogin: false });
        }, 50);
    }

    render() {
        if (!this.state.isLogin) {
            return <Redirect to={"/login"} />;
        }

        const permissionMenus = filterPermission(
            routesConfig.menus.concat(routesConfig.others),
            bus.me.data.accountInfo.perCodes || []
        );

        return (
            <Switch>
                {// Object.keys(routesConfig).map(key =>
                //     routesConfig[key].map(item => {
                //         const route = ele => {
                //             // const Component = AllComponents[ele.component];
                //             // console.log(ele)
                //             return (
                //                 <Route
                //                     key={ele.route || ele.key}
                //                     exact
                //                     path={ele.route || ele.key}
                //                     component={ele.component}
                //                     // render={(props) => <Component {...props}/>}
                //                     // render={props => true ?
                //                     //     <Component {...props} />
                //                     //     : this.requireLogin(<Component {...props} />, '')}
                //                 />
                //             )
                //         }
                //         return item.component ? route(item) : item.subs.map(r => route(r));
                //     })
                // )
                permissionMenus.map(item => {
                    const route = ele => {
                        // const Component = AllComponents[ele.component];
                        // console.log(ele)
                        return (
                            <Route
                                key={ele.route || ele.key}
                                exact
                                path={ele.route || ele.key}
                                component={ele.component}
                                // render={(props) => <Component {...props}/>}
                                // render={props => true ?
                                //     <Component {...props} />
                                //     : this.requireLogin(<Component {...props} />, '')}
                            />
                        );
                    };
                    return item.component
                        ? route(item)
                        : item.subs.map(r => route(r));
                })}
                <Route
                    path="/cps/*"
                    exact
                    render={() => {
                        bus.dispatch("menuRedirect", "/cps/index");
                        return <Redirect to={"/cps/index"} />;
                    }}
                />
                <Route
                    path="/*"
                    exact
                    render={() => <Redirect to={"/login"} />}
                />
            </Switch>
        );
    }
}

export default DefineRoute;
